<template>
<product-detail :item="item" @input="showDetail = $event">
  <template v-slot:income-total>
    <tr><td>Block Reward</td><td><colored :value="item.total.payoff" :digits="2" /></td></tr>
  </template>
  <template v-slot:cost-total="{ item }">
    <tr><td>Upfront Fee</td><td><colored :value="-item.total.upfront" :digits="2" /></td></tr>
    <tr><td>Ongoing Daily Fee</td><td><colored :value="-item.total.fee" :digits="2" /></td></tr>
    <tr><td>Total Cost</td><td><colored :value="-item.total.cost" :digits="2" /></td></tr>
  </template>
  <template v-slot:profit-total="{ item }">
    <tr><td>Net Profit</td><td><colored :value="item.total.payoff - item.total.cost" :digits="2" /></td></tr>
  </template>

  <template v-slot:income>
    <tr><td>Block Reward /Day</td><td><colored :value="item.daily.preHalving.payoff * item.size" :digits="4" /></td></tr>
  </template>
  <template v-slot:cost="{ item }">
    <tr><td>Upfront Fee</td><td><colored :value="-item.daily.upfront * item.size" :digits="4" /></td></tr>
    <tr><td>Ongoing Daily Fee</td><td><colored :value="-item.daily.preHalving.fee * item.size" :digits="4" /></td></tr>
    <tr><td>Total Cost</td><td><colored :value="-item.daily.preHalving.cost * item.size" :digits="4" /></td></tr>
  </template>
  <template v-slot:profit="{ item }">
    <tr><td>Net Profit</td><td><colored :value="(item.daily.preHalving.payoff - item.daily.preHalving.cost) * item.size" :digits="4" /></td></tr>
  </template>

  <template v-slot:income-with-halving>
    <tr><th>Block Reward /{{blockchain[item.coin].unit}}/Day</th></tr>
    <tr><td>Pre-halving</td><td><colored :value="item.daily.preHalving.payoff * item.size" :digits="4" /></td></tr>
    <tr><td>Post-halving</td><td><colored :value="item.daily.postHalving.payoff * item.size" :digits="4" /></td></tr>
  </template>
  <template v-slot:cost-with-halving="{ item }">
    <tr><td>Upfront Fee</td><td><colored :value="-item.daily.upfront * item.size" :digits="4" /></td></tr>
    <tr><td>Ongoing Daily Fee</td><td><colored :value="-item.daily.preHalving.fee * item.size" :digits="4" /></td></tr>
    <tr><td>Total Cost</td><td><colored :value="-item.daily.preHalving.cost * item.size" :digits="4" /></td></tr>
  </template>
  <template v-slot:profit-with-halving="{ item }">
    <tr><th>Net Profit</th><td /></tr>
    <tr><td>Pre-halving</td><td><colored :value="(item.daily.preHalving.payoff - item.daily.preHalving.cost) * item.size" :digits="4" /></td></tr>
    <tr><td>Post-halving</td><td><colored :value="(item.daily.postHalving.payoff - item.daily.postHalving.cost) * item.size" :digits="4" /></td></tr>
  </template>
</product-detail>
</template>

<script>
import { mapState } from "vuex";

import { price, unit, date } from "../../filters";
import Colored from "../Colored";
import ProductDetail from "./ProductDetail";

export default {
  name: "CloudMiningDetail",
  props: ["item"],
  filters: { price, unit, date },
  components: { Colored, ProductDetail },
  computed: {
    ...mapState(["blockchain"])
  }
}
</script>

<style scoped>
</style>